// This import syntax is required for use with Webpack 5 Module Federation
import('./bootstrap');
